import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import { translations } from './translations';


// 定义结果对象的类型
type ResultType = {
  [key: string]: string;
};

// 从统一翻译文件中提取中文翻译
const customTranslations = Object.entries(translations).reduce<ResultType>(
  (result, [key, value]) => {
    result[key] = value['zh-CN'];
    return result;
  },
  {}
);

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...customTranslations, // 添加自定义翻译
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
};
